import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cx from 'classnames';

import Image from './icons/Image';
import { loadImage } from './utils/loadImage';
import generalStyles from './style/general.css';

export default class CardThumbnail extends Component {
  state = {
    imageLoaded: false,
  };

  componentDidMount() {
    this.preloadImage();
  }

  componentDidUpdate(prevProps) {
    if (this.props.thumbnail !== prevProps.thumbnail) {
      this.preloadImage();
    }
  }

  preloadImage() {
    const { thumbnail } = this.props;
    if (thumbnail) {
      loadImage(thumbnail).then(() => this.setState({ imageLoaded: true }));
    }
  }

  render() {
    const { frame, thumbnail, offset } = this.props;

    const containerProps = {
      className: generalStyles.container,
      style: {
        bottom: offset,
      },
    };

    const webOrWatch =
      frame === 'web-frame' ||
      frame === 'apple-watch-42-frame' ||
      frame === 'apple-watch-38-frame';

    const wrapClasses = cx({
      [generalStyles.rounded]: webOrWatch,
      [generalStyles.roundedBottom]: !webOrWatch,
      [generalStyles.wrap]: webOrWatch,
      [generalStyles.wrapBottom]: !webOrWatch,
    });

    const shadowClasses = cx({
      [generalStyles.rounded]: webOrWatch,
      [generalStyles.roundedBottom]: !webOrWatch,
      [generalStyles.shadow]: webOrWatch,
      [generalStyles.shadowBottom]: !webOrWatch,
    });

    if (thumbnail) {
      return (
        <div {...containerProps}>
          <div className={wrapClasses}>
            {this.state.imageLoaded ? (
              <div>
                <img className={generalStyles.image} src={thumbnail} />
                <div className={shadowClasses} />
              </div>
            ) : (
              <div className={generalStyles.loader} />
            )}
          </div>
        </div>
      );
    }

    return (
      <div {...containerProps}>
        <div className={generalStyles.emptyState}>
          <Image />
        </div>
      </div>
    );
  }
}

CardThumbnail.propTypes = {
  frame: PropTypes.string.isRequired,
  offset: PropTypes.number,
  thumbnail: PropTypes.string,
};

CardThumbnail.defaultProps = {
  frame: 'web-frame',
  offset: 0,
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-card/CardThumbnail/index.js